import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const SIGNAL_LABELS = {
  suspected_zombie: "Zombie Suspeitado",
  pending_qr:       "QR Pendente",
  reconnect_loop:   "Loop de Reconexão",
  ack_degraded:     "ACK Degradado",
};

const DANGER_SIGNALS = new Set(["suspected_zombie", "pending_qr"]);

function SignalRow({ label, value, danger }) {
  return (
    <div className="flex items-center justify-between py-1.5 border-b last:border-0">
      <span className="text-sm text-gray-700">{label}</span>
      <span className={`text-xs font-semibold ${
        value ? (danger ? "text-red-600" : "text-amber-600") : "text-gray-400"
      }`}>
        {value ? "SIM" : "não"}
      </span>
    </div>
  );
}

export default function TenantSignalsPanel({ signals }) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold">Sinais de Risco</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {Object.entries(SIGNAL_LABELS).map(([key, label]) => (
          <SignalRow
            key={key}
            label={label}
            value={!!signals[key]}
            danger={DANGER_SIGNALS.has(key)}
          />
        ))}
      </CardContent>
    </Card>
  );
}
